import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityYiDunServiceInfoVO } from '../Type/PackEntityYiDunServiceInfoVO'

interface DataModel {
	aid?: string
	cid?: string
	productType?: 'IM' | 'VOD' | 'LIVE' | 'NET_CALL_G2' | 'GAME_VOICE_STORE'
}

/**
 *	易盾服务版本，功能状态查询
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] aid
 * @param {string} [data.cid] cid
 * @param {'IM'|'VOD'|'LIVE'|'NET_CALL_G2'|'GAME_VOICE_STORE'} [data.productType] 产品类型，不传时只查询基础的是否是安全通+易盾功能状态
 */

export function funcyiDunstatusquery(
	data: DataModel,
	options: IRequestOptionsWithPass,
): Promise<PackEntityYiDunServiceInfoVO>
export function funcyiDunstatusquery(
	data: DataModel,
	options?: IRequestOptions,
): Promise<PackEntityYiDunServiceInfoVO extends { msg: unknown } ? PackEntityYiDunServiceInfoVO['msg'] : undefined>
export function funcyiDunstatusquery(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid, cid, productType } = data
	return net('/frontApi/app/func/yiDun/status/query', {
		method: 'post',
		params: {
			aid,
			cid,
			productType,
		},

		...(options || {}),
	})
}
